import { Maybe, Utils } from '@shared/utils/utils';

export function userFormatter({
  adminUser,
  sub,
  userMap,
}: {
  adminUser: boolean;
  sub: Maybe<string>;
  userMap: Map<
    string,
    {
      email: string;
      family_name: string;
      given_name: string;
    }
  >;
}) {
  const user = userMap.get(sub || '');

  if (user) {
    const isUserAuxAdmin = user.email.includes('@auxili.us');

    if (adminUser || !isUserAuxAdmin) {
      return `${user.given_name} ${user.family_name}`;
    }

    return 'Auxilius Expert';
  }

  return Utils.zeroHyphen;
}
